// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { IShareButton, ShareButton } from './ShareButton'

/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
@Component({
  name: 'ArticleShare',
  components: { ShareButton },
  template: `
    <ul class="article-share list-inline d-lg-none" :class="{ '--hidden': isHidden }">
      <li v-for="shareButton in shareButtons" :key="shareButton.label"
          class="article-share-item">
        <ShareButton v-bind="shareButton" />
      </li>
    </ul>
  `
})
export class ArticleShare extends Vue {
  /**
   * Determines whether the element should be hidden.
   */
  @Prop({ type: Boolean, required: false, default: false })
  public readonly isHidden!: boolean

  /**
   * The array of `<ShareButton>`s which we want to display.
   */
  @Prop({ type: Array, required: true })
  public readonly shareButtons!: IShareButton[]
}

export default ArticleShare
